
































































































































































































































































































































import {Component, Watch, Mixins} from 'vue-property-decorator';
import ConfigModify from '@/components/accumulation/mixins/ConfigurationModify';
import PageTitle from '@/components/common/PageTitle.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {State} from 'vuex-class';
import {Mall} from 'supporter';
@Component({
  components: {
    PageTitle,
    CompSelectBox
  }
})
export default class AccumulationConfigurationModify extends Mixins(ConfigModify) {
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private routeName: string = 'AccumulationConfigurationModify';
  private showForm: boolean = false;

  @Watch('expireNotificationChannelsAll', {immediate: false, deep: true})
  expireNotificationUsable(next: any): void {
    if (next) {
      this.accumulationData.basic.expireNotificationChannels = ['SMS', 'EMAIL'];
    } else {
      if (this.accumulationData.basic.expireNotificationChannels.length === 2) {
        this.accumulationData.basic.expireNotificationChannels = [];
      }
    }
  }
  @Watch('accumulationData.basic.expireNotificationChannels.length', {immediate: false, deep: true})
  NotificationChannelsLength(next: any): void {
    if (next === 2) {
      this.expireNotificationChannelsAll = true;
    } else {
      this.expireNotificationChannelsAll = false;
    }
  }

  private created(): void {}
  private mounted(): void {
    this.init();
  }
  private init(): void {
    this.getAccumulation();
  }
  private getAccumulation(): void {
    this.$api.getAccumulationsConfigurations({params: {
      mallNo: Number(this.$route.params.mallNo)
    }}).then((res) => {
      this.accumulationData = res.data[0];
      this.formatterData(this.accumulationData);
    });
  }
}
